<template>
	<div class="partial auth-demo">
		<div class="details">
			<h3>Try it out!</h3>
			<p>It's the easiest way to quickly find and generate imprisonment, fine, probationary, and supervised release ranges for complex federal criminal cases.</p>
			<p>You will get access to all features, except:</p>
			<ul>
				<li>Limited statutory options and guidelines available</li>
				<li>Case management</li>
				<li>&hellip;that's about it!</li>
			</ul>
		</div>

		<Card>
			<form ref="form" @submit.prevent.stop="submitForm(fields)">
				<div class="form-section">
					<div class="form-section__description">Enter your email and we'll send a link to start your FREE demo.</div>
					<div class="form-row">
						<TextField v-model="fields.email" label="Your Email Address" type="email" class="form__field" :required="true"></TextField>
					</div>
					<div id="recaptcha_box" ref="recaptchaContainer" style="transform:scale(1); transform-origin: left top;">...loading...</div>
				</div>

				<div class="form__message error" v-if="errorMessage">
					{{ errorMessage }}
				</div>

				<div class="form__actions form__actions--horizontal">
					<Button look="form" type="submit" :disabled="isLoading || !fields.token || !$refs.form?.checkValidity()" :loading="isLoading">Start Demo</Button>
				</div>

				<!-- <div class="auth-demo__disclaimer mt-1"><small>By click "Start Demo", you agree to receive emails regarding your experience, product updates and news from Sentencing Pro.</small></div> -->

				<div class="auth-demo__message">
					Just want to get started? <RouterLink :to="{name: 'checkout'}">Join here.</RouterLink>
				</div>
			</form>
		</Card>
	</div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { useUserStore } from '@/lib/store/user'

import Button from '@/components/Button.vue'
import Card from '@/components/Card.vue'
import TextField from '@/components/TextField.vue'


export default {
	name: 'AuthDemo',
	components: {
		Button,
		Card,
		TextField,
	},
	setup() {
		useHead({
			title: `Free Demo`,
			script: [
				{
					src: `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit`,
					type: 'text/javascript',
					async: true,
					defer: true,
					tagPosition: 'bodyClose'
				}
			]
		})

		return {
			userStore: useUserStore(),
		}
	},
	computed: {
		isLoading() {
			return this.userStore.isLoading
		},
	},
	data: () => ({
		fields: {},
		errorMessage: null,
		customers: [],
		recapWidget: null,
	}),
	mounted() {
		window.recaptchaCallback = (token) => {
			this.fields.token = token
		}

		window.onRecaptchaLoad = () => {
			this.renderRecaptcha()
		}

		if (window.grecaptcha && window.grecaptcha.render) {
			this.$nextTick().then(() => {
				this.renderRecaptcha()
			})
		}
	},
	beforeUnmount() {
		try {
			if (typeof grecaptcha !== 'undefined' && this.recapWidget !== null) {
				grecaptcha.reset(this.recapWidget)
			}
		} catch (error) {

		}
		delete window.onRecaptchaLoad
		delete window.recaptchaCallback
	},
	methods: {
		submitForm(fields) {
			this.errorMessage = null
			const { email, token } = fields
			this.userStore.requestLoginLink({email, token})
				.then(() => {
					this.$notice.show(`A link to start your demo has been sent to: ${email}`)
					this.fields = {}

					window.dataLayer = window.dataLayer || []
					window.dataLayer.push({
						event: 'demo_register',
					})
				})
				.catch(error => {
					this.$notice.show(`ERROR: ${error}`)
				})
		},
		renderRecaptcha() {
			if (this.recapWidget != null) return
			if (!this.$refs.recaptchaContainer) return
			if (!window.grecaptcha?.render) return

			try {
				this.recapWidget = window.grecaptcha.render(this.$refs.recaptchaContainer, {
					'sitekey': `6LfXUiEsAAAAAJYRd_61sqXe0qYU8F1KEQq41AsT`,
					'callback': window.recaptchaCallback, // Function to call when verification succeeds
					'error-callback': (err) => {
						console.log('recaptchaError', err)
					},
					theme: 'light',
				})
			} catch (error) {
				console.warn(error)
			}
		}
	},
}
</script>

<style scoped lang="scss">
.auth-demo {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 2rem;
	align-items: center;

	@include modules.media-query('phone') {
		grid-template-columns: 1fr;
		padding: 1rem;
	}

	&__message {
		background-color: var(--color--background-light);
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		font-size: 0.85rem;
		margin-top: 1rem;
		padding: 1rem;
		text-align: center;
	}

	.details {
		color: var(--color--primary-text);
		font-size: 18px;
	}
}
</style>
